export enum StreamProvider {
  Ngage = 'ngage',
  Zoolife = 'zoolife',
}

export type Stream = {
  id: number
  uuid: string
  reference: string
  provider: StreamProvider
  url: string
  view_url: string
  is_online: boolean
  meta: Record<string, any>
  account_is_required: boolean
  account_is_linked: boolean
}

export type StreamData = {
  provider: StreamProvider
  reference: string
  meta?: Record<string, any>
}